export enum UserRole {
  ADMIN = "ADMIN",
  CLIENT = "CLIENT"
}

export function getRoles():string[] {
  return Object.values(UserRole).filter((r:any) => isNaN(r)) as string[]
}